export class SiloRealCredentials {
  username: string;
  password: string;
  /** La contraseña es de solo escritura: el back solo informa si hay una guardada. */
  has_password?: boolean;
}
